"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Stack = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const react_1 = require("react");
const lib_1 = require("../lib");
const variables = {
    spacing: '--spacing',
};
const setDefaultMargin = (theme, spacing) => {
    if (!spacing) {
        return theme.spacing.small;
    }
    return (0, lib_1.isNominalSpacingValue)(spacing) ? spacing : theme.spacing[spacing];
};
const styles = {
    StackWrap: {
        horizontal: () => (0, app_1.css) `
      flex-direction: row;
      & > *:not(style):not(form) ~ *:not(style):not(form) {
        margin-top: 0;
        margin-left: var(${variables.spacing});
      }
    `,
        vertical: (align = 'normal') => (0, app_1.css) `
      flex-direction: column;
      align-items: ${align};
      & > *:not(style):not(form) ~ *:not(style):not(form) {
        margin-left: 0;
        margin-top: var(${variables.spacing});
      }
    `,
    },
};
const stackStyle = (kind, spacing, mobileKind, align, fullWidth, fullHeight) => (0, app_1.css) `
  ${fullWidth && 'width: 100%'};
  ${fullHeight && 'height: 100%'};
  // FIXME: vscode-styled-components extension
  > * {
    ${(theme) => `${variables.spacing}: ${setDefaultMargin(theme, spacing)}`};
  }
  display: flex;
  ${kind && styles.StackWrap[kind](align)}

  @media ${app_1.mobile} {
    ${mobileKind && styles.StackWrap[mobileKind](align)}
  }
`;
const StackWrap = app_1.styled.div `
  ${(_, { $kind, $spacing, $mobileKind, $align, $fullWidth, $fullHeight }) => stackStyle($kind, $spacing, $mobileKind, $align, $fullWidth, $fullHeight)}
`;
const StackWrapList = app_1.styled.ul `
  padding: 0;
  margin: 0;
  ${(_, { $kind, $spacing, $mobileKind }) => stackStyle($kind, $spacing, $mobileKind)}
  list-style-type: none;
`;
const DividerHorizontal = app_1.styled.div `
  min-height: 1px;
  width: auto;
  background: ${(theme) => theme.stroke};
`;
const DividerVertical = app_1.styled.div `
  height: auto;
  min-width: 1px;
  background: ${(theme) => theme.stroke};
`;
exports.Stack = (0, react_1.forwardRef)(({ children, kind = 'horizontal', mobileKind, divider: Divider, list, spacing, fullWidth, fullHeight, align, onClick, className, }, ref) => {
    const childrenNodes = Divider && Array.isArray(children)
        ? react_1.Children.map(children.flat(), (child, i) => {
            var _a;
            const last = i === ((_a = children === null || children === void 0 ? void 0 : children.flat()) === null || _a === void 0 ? void 0 : _a.length) - 1;
            if (!child) {
                return null;
            }
            const DividerElem = Divider === true ? (kind === 'horizontal' ? ((0, jsx_runtime_1.jsx)(DividerVertical, {})) : ((0, jsx_runtime_1.jsx)(DividerHorizontal, {}))) : ((0, jsx_runtime_1.jsx)(Divider, {}));
            return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [child, !last && DividerElem] }, 'key' in child ? child.key : i));
        })
        : children;
    const Wrap = list ? StackWrapList : StackWrap;
    return ((0, jsx_runtime_1.jsx)(Wrap, Object.assign({ ref: ref, "$spacing": spacing, "$kind": kind, "$mobileKind": mobileKind, "$fullWidth": fullWidth, "$align": align, "$fullHeight": fullHeight, className: className, onClick: onClick }, { children: childrenNodes })));
});
exports.Stack.variables = variables;
